module.exports = __webpack_public_path__ + "img/tzc.226b2700.svg";